import React from "react";
import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  Tooltip,
  Button,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { Label } from "semantic-ui-react";

export default function VerificationGrid({
  data,
  onClose,
  postCreateMultiple,
  setIsLoading,
}) {
  function processMultipleAgreement() {
    setIsLoading(true);
    postCreateMultiple();
  }

  return (
    <>
      <Grid className="c-grid-results">
        <TableContainer style={{ overflow: "initial" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="c-text-center" fullWidth={true}>
                  <b>Estado</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Canal de Venta</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Producto</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Categoría Externa</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Tipo de Documento</b>
                </TableCell>
                <TableCell className="c-text-center" fullWidth={true}>
                  <b>Número de Documento</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Nombre del Asegurado</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Apellido del Asegurado</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Fecha de Nacimiento</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Dirección</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Código Postal</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Localidad</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Provincia</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Nro. de Teléfono</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Email</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Medio de Pago</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>Número de Tarjeta</b>
                </TableCell>
                <TableCell className="c-text-center">
                  <b>CBU</b>
                </TableCell>
              </TableRow>
            </TableHead>
            {data && data.listaRegistros && (
              <TableBody>
                {data.listaRegistros.map(
                  ({
                    estado,
                    nombreProducto,
                    nombreCanalDeVenta,
                    nombreProductoCategoria,
                    cliente: {
                      nombreTipoDocumento,
                      numeroDocumento,
                      nombre,
                      apellido,
                      fechaNacimiento,
                      nombreProvincia,
                      nombreLocalidad,
                      codigoPostal,
                      direccion,
                      telefonoMovil,
                      email,
                    },
                    metodoDePago: { nombreMedioPago, numeroTarjeta, cbu },
                    detalle,
                  }) => (
                    <TableRow key={numeroDocumento}>
                      {estado ? (
                        <TableCell>
                          <CheckIcon style={{ color: "green" }}></CheckIcon>
                        </TableCell>
                      ) : (
                        <TableCell>
                          <Tooltip title={detalle}>
                            <CloseIcon style={{ color: "red" }}></CloseIcon>
                          </Tooltip>
                        </TableCell>
                      )}
                      <TableCell>{nombreCanalDeVenta}</TableCell>
                      <TableCell>{nombreProducto}</TableCell>
                      <TableCell>{nombreProductoCategoria}</TableCell>
                      <TableCell>{nombreTipoDocumento}</TableCell>
                      <TableCell>{numeroDocumento}</TableCell>
                      <TableCell>{nombre}</TableCell>
                      <TableCell>{apellido}</TableCell>
                      <TableCell>{fechaNacimiento}</TableCell>
                      <TableCell>{direccion}</TableCell>
                      <TableCell>{codigoPostal}</TableCell>
                      <TableCell>{nombreLocalidad}</TableCell>
                      <TableCell>{nombreProvincia}</TableCell>
                      <TableCell>{telefonoMovil}</TableCell>
                      <TableCell>{email}</TableCell>
                      <TableCell>{nombreMedioPago}</TableCell>
                      <TableCell>{numeroTarjeta}</TableCell>
                      <TableCell>{cbu}</TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Grid style={{ marginTop: "5px" }}>
          <Button
            variant="contained"
            onClick={() => onClose()}
            style={{ marginLeft: "5px" }}>
            Cerrar
          </Button>
          <Button
            onClick={() => processMultipleAgreement()}
            variant="contained"
            className="c-btn-success"
            style={{ marginLeft: "5px" }}>
            Procesar
          </Button>
          <Label
            style={{
              marginLeft: "15px",
              "background-color": "#AED6F1",
            }}>
            Registros Totales: {data.registrosTotales}
          </Label>
          <Label style={{ marginLeft: "5px", "background-color": "#A9DFBF" }}>
            Registros Previsualizados: {data.registrosProcesados}
          </Label>
          <Label style={{ marginLeft: "5px", "background-color": "#F5B7B1" }}>
            Registros Inconsistentes: {data.registrosConError}
          </Label>
        </Grid>
      </Grid>
    </>
  );
}
